<template>
  <div class="carousel-nav">
    <a href="#" @click.prevent="$emit('nav-to', currentSlide - 1)">
      <i class="fal fa-chevron-left"></i>
    </a>
    <a href="#" @click.prevent="$emit('nav-to', currentSlide + 1)">
      <i class="fal fa-chevron-right"></i>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    currentSlide: Number
  }
}
</script>

<style lang="scss">
.carousel-nav {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  display: flex;
  justify-content: space-between;
  align-items: center;

  pointer-events: none;

  a {
    pointer-events: all;
  }
}
</style>
